window.onload = function() {
  handleVariantImageChange();
};

//PRODUCT GALLERY ITEM SWITCHER
var gridItems = document.querySelectorAll('div.product-img-grid-item');
console.log('🖼️ Grid items found:', gridItems.length);

if(gridItems){
  gridItems.forEach(function(smallPicture) {
    console.log('📦 Setting up click handler for:', smallPicture.getAttribute("mediaType"));
    if(smallPicture.getAttribute("mediaType") == "image"){
      smallPicture.addEventListener('click', function() {
        console.log("🖱️ Thumbnail clicked:", smallPicture);
        changeMainWithIncomingMedia(smallPicture.querySelector("img"), "image");
      });
    }
    else if(smallPicture.getAttribute("mediaType") == "video"){
      smallPicture.addEventListener('click', function() {
        changeMainWithIncomingMedia(smallPicture.querySelector("video"), "video");
      });
    }
    else if(smallPicture.getAttribute("mediaType") == "model"){
      smallPicture.addEventListener('click', function() {
        changeMainWithIncomingMedia(smallPicture.querySelector("model-viewer"), "model");
      });
    }
    else if(smallPicture.getAttribute("mediaType") == "external_video"){
      smallPicture.addEventListener('click', function() {
        changeMainWithIncomingMedia(smallPicture.querySelector("iframe"), "iframwe");
      });
    }
  });
}

function changeMainWithIncomingMedia(smallPicture, mediaType) {
  console.log('🔄 changeMainWithIncomingMedia called with:', smallPicture, mediaType);
  var main = document.querySelectorAll('div.featured-product-image')[0];

  console.log('🎯 Main container found:', main);

  if (!main) {
    console.error('❌ Main container not found!');
    return;
  }

  // Lock container height to prevent CLS
  var currentHeight = main.offsetHeight;
  main.style.minHeight = currentHeight + 'px';
  console.log('📏 Container height locked at:', currentHeight + 'px');

  // Remove existing content
  while (main.firstChild) {
    main.removeChild(main.firstChild);
  }
  console.log('🗑️ Existing content removed');

  var mediaToBeMain = smallPicture.cloneNode(true);
  mediaToBeMain.setAttribute("id", "main-product-image");

  // Use full-res image for main display if available
  if (mediaType === "image" && mediaToBeMain.dataset.fullSrc) {
    console.log('📸 Using full-res src:', mediaToBeMain.dataset.fullSrc);
    mediaToBeMain.src = mediaToBeMain.dataset.fullSrc;
  } else {
    console.log('⚠️ No data-full-src found, using original src:', mediaToBeMain.src);
  }

  // Apply main image styles (matching product-media-main.liquid)
  if (mediaType === "image") {
    // Hide until loaded to prevent flash of stretched image (Safari fix)
    mediaToBeMain.style.cssText = 'opacity: 0; display: block; margin-right: auto; margin-left: auto; max-height: 70vh; width: auto; max-width: 100%; height: auto; object-fit: contain;';
    // Show and release height lock after image loads
    mediaToBeMain.onload = function() {
      mediaToBeMain.style.opacity = '1';
      main.style.minHeight = '';
      console.log('🔓 Image loaded and visible');
    };
  } else {
    mediaToBeMain.style.display = 'block';
    main.style.minHeight = '';
  }

  main.appendChild(mediaToBeMain);
  console.log('✅ New main image appended:', mediaToBeMain.src);
}

function handleVariantImageChange() {
  //console.log('handleVariantImageChange function called');
  const variantInput = document.getElementById('ultimate-selected-variant');
  const productData = JSON.parse(document.getElementById('product-data').dataset.product);

  //console.log('Variant input:', variantInput);
 // console.log('Product data:', productData);

  if (!variantInput) {
    //console.error('Variant input not found');
    return;
  }

  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      //console.log('Mutation detected:', mutation);
      if (mutation.type === 'attributes' && mutation.attributeName === 'value') {
        const selectedVariantId = parseInt(variantInput.value);
        //console.log('Selected variant ID:', selectedVariantId);
        const selectedVariant = productData.variants.find(variant => variant.id === selectedVariantId);

       // console.log('Selected variant:', selectedVariant);

        if (selectedVariant && selectedVariant.featured_image) {
         // console.log('Updating main image to:', selectedVariant.featured_image.src);
          
          // Find the thumbnail with the matching image
          const matchingThumbnail = document.querySelector(`div.product-img-grid-item img[src="${selectedVariant.featured_image.src}"]`);
          //console.log('Matching thumbnail:', matchingThumbnail);
          
          if (matchingThumbnail) {
            // Use the existing changeMainWithIncomingMedia function
            changeMainWithIncomingMedia(matchingThumbnail, "image");
            
            // Update the selected state of thumbnails
            const thumbnails = document.querySelectorAll('div.product-img-grid-item');
            thumbnails.forEach(thumbnail => {
              if (thumbnail.querySelector('img').src === selectedVariant.featured_image.src) {
                thumbnail.classList.add('selected');
              } else {
                thumbnail.classList.remove('selected');
              }
            });

            //console.log('Main image updated and thumbnails refreshed');
          } else {
            //console.error('Matching thumbnail not found');
          }
        } else {
          //console.log('Selected variant has no featured image');
        }
      }
    });
  });

  observer.observe(variantInput, { attributes: true });
  //console.log('Observer set up for variant input');
}

// Call this function when the page loads
window.addEventListener('DOMContentLoaded', (event) => {
  handleVariantImageChange();
});